export default {"src":"/_next/static/image/public/images/ic_upload_prescription_homecare.ea1c512a01c831d729b6937656e30752.svg","height":61,"width":56};